const Eloquent = window.Eloquent;

/**
 * Get list of all existing groups
 * @returns {Promise}
 */
export function getGroups() {
    return Eloquent.Group.getAllGroups();
    //return Eloquent.Group.getAll();
}

/**
 * delete a group
 * @param {Number} id
 * @returns {Promise}
 */
export function deleteGroup(id) {
    return Eloquent.Group.deleteOne(id);
}

/**
 * get group reports details
 * @param {Number} id
 * @returns {Promise}
 */
export function getReportsDetails(id) {
    return Eloquent.Group.getReportsDetails(id);
}

/**
 * export create a group
 * @param {Object} data
 * @returns {Promise}
 */
export function createGroup(data) {
    return Eloquent.Group.createOne(data);
}

/**
 * update a group
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function updateGroup(id, data) {
    return Eloquent.Group.updateOne(id, data);
}


/**
 * get a group
 * @param {Number} id
 * @returns {Promise}
 */
export function getGroup(id) {
    return Eloquent.Group.getOne(id);
}


/**
 * join a group as user (only for admin, the first time he joins a group)
 * @param {String} key group access key
 * @returns {Promise}
 */
export function addAsUser(key) {
    return Eloquent.Group.addAsUser(key);
}


/**
 * Invite users to group
 * @param {Number} id
 * @param {Array} users
 * @returns {Promise}
 */
export function inviteGroup(id, users) {
    return Eloquent.Group.invite(id, {
        'contact_ids': users
    });
}

/**
 * Invite users to group
 * @param {Number} id
 * @param {Array} users
 * @returns {Promise}
 */
export function inviteNewGroup(id, users) {
    return Eloquent.Group.invite(id, {
        'contacts': users
    });
}

/**
 * export initial plans for primary agenda of a group
 * @param {Number} id
 * @returns {Promise}
 */
export function exportGroupPrimaryInitials(id) {
    return Eloquent.Group.exportInitialPrimaryAgendas(id);
}

/**
 * export initial plans for secondary agenda of a group
 * @param {Number} id
 * @returns {Promise}
 */
export function exportGroupSecondaryInitials(id) {
    return Eloquent.Group.exportInitialSecondaryAgendas(id);
}

/**
 * export ongoing plans for primary agenda of a group
 * @param {Number} id
 * @returns {Promise}
 */
export function exportGroupPrimaryOngoings(id) {
    return Eloquent.Group.exportOngoingPrimaryAgendas(id);
}

/**
 * export ongoing plans for secondary agenda of a group
 * @param {Number} id
 * @returns {Promise}
 */
export function exportGroupSecondaryOngoing(id) {
    return Eloquent.Group.exportOngoingSecondaryAgendas(id);
}

/**
 * remove user from group
 * @param {Number} groupId
 * @param {Number} userId
 * @returns {Promise}
 */
export function removeGroupUser(groupId, userId) {
    return Eloquent.Group.deleteUser(groupId, {
        'user_id': userId
    });
}



// WEBPACK FOOTER //
// ./src/api/group.js